var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCaretDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.058 12.275c.521.52 1.367.52 1.888 0l5.333-5.333c.383-.384.496-.955.288-1.455a1.334 1.334 0 0 0-1.234-.825l-10.666.005a1.338 1.338 0 0 0-.946 2.279l5.333 5.333.004-.004Z"
})));
export default SvgCaretDownIcon;